<template>
  <div id="app">
    <router-view v-if="$route.matched.length"/>
    <p v-else role="status">正在加载页面并恢复登录，请稍候…</p>
  </div>
</template>

<script>
import { saveStoreState } from '@/store/persist'

export default {
  name: 'App',
  data(){
    return {
      pageWasHidden:false,
      lastResumeAt:0,
      resumeRepairAttempts:0,
      resumeRepairTimer:null
    }
  },
  created(){
    // 2026-10-05：登录只由 store 在启动前恢复一次，不再覆盖路由检查已经恢复的资料。
    // 登录成功已立即保存；beforeunload 只用于补存当前有效状态。
    window.addEventListener('beforeunload', this.saveCurrentStore);
  },
  mounted(){
    // 2026-10-02：微信把网页切到后台时，旧版 WebView 可能暂停 Vant 的关闭动画，
    // 从而留下透明遮罩、触摸锁或永远等待的页面状态。根组件统一处理全部业务页面。
    document.addEventListener('visibilitychange',this.onVisibilityChange)
    window.addEventListener('pagehide',this.onPageHide)
    window.addEventListener('pageshow',this.onPageShow)
  },
  beforeDestroy(){
    window.removeEventListener('beforeunload',this.saveCurrentStore)
    document.removeEventListener('visibilitychange',this.onVisibilityChange)
    window.removeEventListener('pagehide',this.onPageHide)
    window.removeEventListener('pageshow',this.onPageShow)
    window.clearTimeout(this.resumeRepairTimer)
  },
  methods:{
    // 2026-10-05：读取缓存暂时失败时，不能用默认未登录状态覆盖原来仍有效的登录记录。
    saveCurrentStore(){
      if(this.$store.getters.getLoginState){
        saveStoreState(this.$store.state)
      }
    },
    onVisibilityChange(){
      if(document.visibilityState === 'hidden'){
        this.pageWasHidden = true
        return
      }
      if(this.pageWasHidden){
        this.recoverAfterResume()
      }
    },
    onPageHide(){
      this.pageWasHidden = true
    },
    onPageShow(event){
      if(event.persisted || this.pageWasHidden){
        this.recoverAfterResume()
      }
    },
    // 2026-10-02：微信恢复后不刷新、不重建页面，也不关闭仍然可见的正常弹窗。
    // 只在没有任何可见弹层时清理孤立遮罩和 body 滚动锁，保留当前输入与操作现场。
    recoverAfterResume(){
      const now = Date.now()
      if(now - this.lastResumeAt < 300) return
      this.lastResumeAt = now
      this.pageWasHidden = false
      this.resumeRepairAttempts = 0
      window.clearTimeout(this.resumeRepairTimer)
      this.$nextTick(() => {
        // 等微信 WebView 完成可见区域恢复，再判断弹层是否真的仍在屏幕内。
        this.resumeRepairTimer = window.setTimeout(this.clearStaleInteractionLock,150)
      })
    },
    // 2026-10-02：只认定实际占据屏幕区域的弹层为“正在使用”，不能仅凭 DOM 是否存在判断。
    // 例如 Vant 为动画保留但已经移出屏幕的 Popup，不应继续阻挡页面点击。
    isVisibleLayer(element){
      if(!element) return false
      const style = window.getComputedStyle(element)
      if(style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false
      const rect = element.getBoundingClientRect()
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth
    },
    // 2026-10-02：修复微信恢复后偶发的透明遮罩残留。
    // 有可见弹窗时一律不处理；没有弹窗时先模拟点击，让 Vant 自己释放监听，再移除确实孤立的遮罩。
    clearStaleInteractionLock(){
      // 微信恢复早期偶尔会报告 0×0 视口，此时不能把正常弹窗误判成不可见。
      if(window.innerWidth <= 0 || window.innerHeight <= 0){
        if(this.resumeRepairAttempts < 5){
          this.resumeRepairAttempts += 1
          this.resumeRepairTimer = window.setTimeout(this.clearStaleInteractionLock,100)
        }
        return
      }
      const layerSelectors = '.van-popup,.van-dialog,.van-action-sheet,.van-popover'
      const hasVisibleLayer = Array.from(document.querySelectorAll(layerSelectors)).some(this.isVisibleLayer)
      if(hasVisibleLayer) return

      const overlays = Array.from(document.querySelectorAll('.van-overlay'))
      overlays.forEach(overlay => overlay.click())
      this.$nextTick(() => {
        const stillHasVisibleLayer = Array.from(document.querySelectorAll(layerSelectors)).some(this.isVisibleLayer)
        if(stillHasVisibleLayer) return
        document.querySelectorAll('.van-overlay').forEach(overlay => {
          if(overlay.parentNode) overlay.parentNode.removeChild(overlay)
        })
        document.body.classList.remove('van-overflow-hidden')
      })
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
